export default __webpack_public_path__ + "static/media/Green_check.27e55988.svg";